import { render } from "./NewIndividualTestCardSessionResults.vue?vue&type=template&id=5548f748&scoped=true"
import script from "./NewIndividualTestCardSessionResults.vue?vue&type=script&lang=js"
export * from "./NewIndividualTestCardSessionResults.vue?vue&type=script&lang=js"

import "./NewIndividualTestCardSessionResults.vue?vue&type=style&index=0&id=5548f748&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5548f748"]])

export default __exports__